/* LIOR carousel: prev/next buttons + scroll progress bar for CSS scroll-snap tracks.
   Markup: [data-lior-carousel] contains
     [data-lior-carousel-track]                      the scrolling list
     [data-lior-carousel-prev] / [data-lior-carousel-next]   optional arrow buttons
     [data-lior-carousel-progress] > [data-lior-carousel-progress-thumb]   optional progress bar
   The root gets .lior-carousel--static when the track does not overflow.
   window.LiorCarousel.refresh(scope) re-measures roots after their content changes. */
(function () {
  'use strict';

  if (window.LiorCarousel) {
    window.LiorCarousel.init(document);
    return;
  }

  var ROOT_SELECTOR = '[data-lior-carousel]';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function setup(root) {
    if (!root || root.__liorCarousel) return;
    var track = root.querySelector('[data-lior-carousel-track]');
    if (!track) return;
    root.__liorCarousel = true;

    var prev = root.querySelector('[data-lior-carousel-prev]');
    var next = root.querySelector('[data-lior-carousel-next]');
    var progress = root.querySelector('[data-lior-carousel-progress]');
    var thumb = progress ? progress.querySelector('[data-lior-carousel-progress-thumb]') : null;

    function gap() {
      var style = window.getComputedStyle(track);
      var value = parseFloat(style.columnGap || style.gap);
      return isNaN(value) ? 0 : value;
    }

    function update() {
      var scrollWidth = track.scrollWidth;
      var clientWidth = track.clientWidth;
      var max = scrollWidth - clientWidth;
      var overflowing = max > 2;
      var left = Math.abs(track.scrollLeft);
      root.classList.toggle('lior-carousel--static', !overflowing);
      if (prev) prev.disabled = !overflowing || left <= 2;
      if (next) next.disabled = !overflowing || left >= max - 2;

      if (thumb) {
        var visible = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
        var position = overflowing ? Math.min(1, Math.max(0, left / max)) : 0;
        var widthPct = visible * 100;
        thumb.style.width = widthPct + '%';
        thumb.style.left = (position * (100 - widthPct)) + '%';
      }
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }

    function go(direction) {
      var distance = track.clientWidth + gap();
      track.scrollBy({ left: direction * distance, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(track);
    }
    window.addEventListener('load', schedule);

    root.__liorCarouselUpdate = schedule;
    update();
  }

  function roots(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var list = [];
    if (context.matches && context.matches(ROOT_SELECTOR)) list.push(context);
    var found = context.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < found.length; i++) list.push(found[i]);
    return list;
  }

  function init(scope) {
    var list = roots(scope);
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  function refresh(scope) {
    var list = roots(scope);
    for (var i = 0; i < list.length; i++) {
      if (!list[i].__liorCarousel) setup(list[i]);
      else if (list[i].__liorCarouselUpdate) list[i].__liorCarouselUpdate();
    }
  }

  window.LiorCarousel = { init: init, refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
